export const FOOTER_LINKS_CONTACT: LinkListProps = {
  title: 'Contato',
  linkList: [
    {
      href: '/',
      label: 'Chamada de vídeo',
    },
    {
      href: '/',
      label: 'Degustação',
    },
    {
      href: '/',
      label: 'Demonstração',
    },
  ],
};

export const FOOTER_LINKS_MODELS: LinkListProps = {
  title: 'Modelos',
  linkList: [
    {
      href: '/',
      label: 'Tradicionais',
    },
    {
      href: '/',
      label: 'Gourmet',
    },
    {
      href: '/',
      label: 'Castanhas',
    },
    {
      href: '/',
      label: 'Etílicos',
    },
    {
      href: '/',
      label: 'Banhados',
    },
    {
      href: '/',
      label: 'Artesanais',
    },
    {
      href: '/',
      label: 'Exóticos',
    },
  ],
};

export const FOOTER_LINKS_WWA: LinkListProps = {
  title: 'Quem Somos',
  linkList: [
    {
      href: '/',
      label: 'História',
    },
    {
      href: '/',
      label: 'Valores',
    },
    {
      href: '/',
      label: 'Missão',
    },
  ],
};

export const SOCIAL_MEDIA_LINKS: SocialMediaLink[] = [
  {
    icon: 'facebook',
  },
  {
    icon: 'instagram',
  },
  {
    icon: 'twitter',
  },
  {
    icon: 'snapchat',
  },
  {
    icon: 'youtube',
  },
];
